import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '2fr 4fr 3fr 3fr 5fr 4fr',
    padding: '16px 0 16px 12px',
    marginTop: 4,
    alignItems: 'center',
    borderRadius: 4,
    color: 'grey',
    textAlign: 'center'
  }
}))
export default useStyles
